import { createFileRoute } from '@tanstack/react-router';
import { FormsDetailsRouteView } from '@/pages/workspaces/integrations/forms/routing';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/integrations/forms_/$type_/$formId')({
  component: FormDetailsRoute,
});

function FormDetailsRoute() {
  const { workspaceId, type, formId } = Route.useParams();
  return <FormsDetailsRouteView workspaceId={String(workspaceId)} type={type} formId={formId} />;
}
